module.exports = __webpack_public_path__ + "static/11-5d37a0febcd9a4096f5e3ea339f91911.mp4";